/**
 * @generated SignedSource<<ada35640e45c98f6dac8db857a32111c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView">;
  readonly " $fragmentType": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell";
};
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key = {
  readonly " $data"?: linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "e76aa9e40f9ed0b04d7cf28cc38daf52";

export default node;
